import {FilterForm} from "./bonuswelten/FilterForm";
import {Card} from "./bonuswelten/Card";
import {Pagination} from "./bonuswelten/Pagination";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {Form, Formik} from "formik";
import * as DataHelpers from './bonuswelten/DataHelpers'
import {CompanyDetailsModal} from "./bonuswelten/CompanyDetailsModal";
import {useAutoAnimate} from "@formkit/auto-animate/react";

export function Bonuswelten() {

    const [isLoaded, setIsLoaded] = useState(false);
    DataHelpers.init().then(() => setIsLoaded(true));


    const initialOffers = DataHelpers.getSortedOffers();

    const history = useHistory();
    const [hash, query] = history.location.search.split('?')
    let searchParams = query ? new URLSearchParams(query) : new URLSearchParams('')

    const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1)
    const [category, setCategory] = useState(parseInt(searchParams.get('category')) || DataHelpers.getCategories()[0]?.id)
    const [filter, setFilter] = useState(searchParams.get('filter') || 'all')
    const [sort, setSort] = useState(searchParams.get('sort') || 'popular')
    const [search, setSearch] = useState(searchParams.get('search') || '')
    const [open, setOpen] = useState(parseInt(searchParams.get('open')) || null);
    const [parent] = useAutoAnimate()

    const itemsPerPage = 30;

    function filterOffers(page, category, filter, sort, search, open) {
        let filteredOffers = initialOffers;
        if (search) {
            filteredOffers = DataHelpers.search(filteredOffers, search)
            searchParams = DataHelpers.setSearchParams('search', search, searchParams)
        }
        if (sort) {
            filteredOffers = DataHelpers.sortOffersBy(filteredOffers, sort)
            searchParams = DataHelpers.setSearchParams('sort', sort, searchParams)
        }
        if (category >= 0) {
            filteredOffers = DataHelpers.filterByCategory(filteredOffers, category)
            searchParams = DataHelpers.setSearchParams('category', category, searchParams)
        }
        if (filter) {
            filteredOffers = DataHelpers.filterOffers(filteredOffers, filter)
            searchParams = DataHelpers.setSearchParams('filter', filter, searchParams)
        }
        return filteredOffers;
    }

    function setQueryParams(params) {
        Object.keys(params).map(key => {
            if (searchParams.get(key) !== params[key]) {
                searchParams.set(key, params[key])
            }
        });
        if (history.location.search !== "?" + searchParams.toString()) {
            history.push({search: "?" + searchParams.toString()});
        }
    }

    const filteredOffers = filterOffers(page, category, filter, sort, search, open)
    const filteredMaxPages = Math.max(1, Math.ceil(filteredOffers.length / itemsPerPage));
    setQueryParams({
        page: page?.toString() || '1',
        category: category?.toString() || '',
        filter: filter?.toString() || '',
        sort: sort?.toString() || '',
        search: search?.toString() || '',
        open: open?.toString() || ''
    })
    if (page > filteredMaxPages) {
        setPage(filteredMaxPages)
    }
    const paginatedOffers = filteredOffers.slice((page - 1) * itemsPerPage, page * itemsPerPage);

    if(!isLoaded) {
        return (<div>Loading...</div>)
    }

    return (
        <>
            <CompanyDetailsModal show={open !== null}
                                 setOpen={setOpen}
                                 currentItem={DataHelpers.getOfferById(open)}
            />

            <div className="w-full flex flex-col">
                <h1 className="block font-bold p-6 text-2xl md:text-4xl lg:text-5xl">Stadtwerke Bonuswelt: Aktuelle Angebote</h1>
                <Formik
                    initialValues={{
                        search,
                        filter,
                        category,
                        sort
                    }}
                >
                    {({values}) => (
                        <Form>
                            <FilterForm setSearch={setSearch} setSort={setSort} setFilter={setFilter}
                                        setCategory={setCategory}>
                            </FilterForm>
                            {paginatedOffers.length > 0 ?
                                <ul role="list"
                                    ref={parent}
                                    className="grid grid-cols-1 px-4 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                    {paginatedOffers.map((offer) => (
                                            <li key={offer.id} className="col-span-1 p-2 sm:p-4 h-full">
                                                <Card setOpen={setOpen} offer={offer}></Card>
                                            </li>
                                    ))}
                                </ul>
                                :
                                <TransitionGroup>
                                    <CSSTransition
                                        timeout={300}
                                        classNames='fade'
                                    >
                                        <div className="w-full justify-center flex text-2xl my-4 text-gray-900">Es
                                            wurden
                                            keine
                                            Einträge
                                            gefunden!
                                        </div>
                                    </CSSTransition>
                                </TransitionGroup>
                            }
                            <Pagination page={page} setPage={setPage} itemsPerPage={itemsPerPage}
                                        itemsTotal={filteredOffers.length}></Pagination>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}
